export default {"unseen": "UNSEEN", 
                "rejected": "REJECTED",
                "validated": "VALIDATED",
                "notuploaded": "NOTUPLOADED"   
                };